const INTERNAL_ERROR_PATTERN =
  /relation|policy|RLS|postgres|JWT|duplicate key|violates|permission denied|42P|23505|23503|PGRST/i;

/**
 * User-facing error text. Avoids leaking schema, policy, or stack details.
 */
export function safeUserErrorMessage(
  error,
  fallback = "Something went wrong. Please try again.",
) {
  if (!error) {
    return fallback;
  }

  if (typeof error === "string") {
    if (error.length > 240 || INTERNAL_ERROR_PATTERN.test(error)) {
      return fallback;
    }
    return error;
  }

  const message = error.message;
  if (
    typeof message === "string" &&
    message.length <= 240 &&
    !INTERNAL_ERROR_PATTERN.test(message)
  ) {
    return message;
  }

  return fallback;
}

export function isInternalErrorMessage(message) {
  return (
    typeof message === "string" && INTERNAL_ERROR_PATTERN.test(message)
  );
}
